/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { InterestsIcon } from '../../../icons/icons'
import ApiFunction from '../../../../utils/api/apiFuntions';
import { useDispatch, useSelector } from 'react-redux';
import { setInterestData } from '../../../redux/onboadingDataSlice';
import { Spinner } from 'react-bootstrap';
import { decryptData } from '../../../../utils/api/encrypted';

const INTERESTS_REQUIRED = 5;
const ONBOARDING_KEY = 'onboarding_completed';
const LEGACY_ONBOARDING_KEY = 'onboading_completed';

const Interests = ({ setStep }) => {

    const encryptedToken = useSelector(state => state?.appData?.userToken);
    const user_id = decryptData(encryptedToken);
    const prevSelectedData = useSelector(state => state?.onboading?.interests);
    const [selectedInterests, setSelectedInterests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [interestsList, setInterestsList] = useState([]);
    const [sortedInterestsList, setSortedInterestsList] = useState([]);
    const { post } = ApiFunction();
    const dispatch = useDispatch();
    const data = new FormData();
    data.append('type', 'get_data');
    data.append('table_name', 'interests');

    useEffect(() => {
        if (prevSelectedData && prevSelectedData?.length > 0) {
            setSelectedInterests(prevSelectedData);
        }
    }, [prevSelectedData])

    useEffect(() => {
        const getInterestsList = async () => {
            setLoading(true);
            await post('', data)
                .then(response => {
                    if (response) {
                        setInterestsList(response?.data);
                    } else {
                        console.log("the response from server is not correct");
                    }
                })
                .catch(err => {
                    console.log("there is an error in the response =>", err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }

        getInterestsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Sort interests by text length - shorter text first
    useEffect(() => {
        if (interestsList && interestsList.length > 0) {
            const sorted = [...interestsList].sort((a, b) => {
                const nameA = a.name || '';
                const nameB = b.name || '';
                return nameA.length - nameB.length;
            });
            setSortedInterestsList(sorted);
        }
    }, [interestsList]);

    const handleCheckboxChange = (event, interest) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            if (selectedInterests?.length < INTERESTS_REQUIRED) {
                setSelectedInterests(prev => [...prev, interest]);
            }
        } else {
            setSelectedInterests(prev => prev?.filter(item => item !== interest));
        }
    };

    const profileData = useSelector(state => state?.onboading?.OnboadingProfile);

    const markOnboardingCompleted = () => {
        localStorage.setItem(ONBOARDING_KEY, 'true');
        localStorage.removeItem(LEGACY_ONBOARDING_KEY);
    };

    const handleContinue = async () => {
        if (selectedInterests.length !== INTERESTS_REQUIRED) {
            alert(`Please select exactly ${INTERESTS_REQUIRED} interests`);
            return;
        }

        setSubmitting(true);

        try {
            const formData = new FormData();

            formData.append('type', 'update_data');
            formData.append('table_name', 'users');
            formData.append('id', user_id);
            formData.append('designation', profileData?.designation || '');
            formData.append('company', profileData?.company || '');
            formData.append('industry', profileData?.industries || '');
            formData.append('gender', profileData?.gender || '');

            const languagesJson = JSON.stringify(profileData?.languages || []);
            const interestsJson = JSON.stringify(selectedInterests);

            formData.append('languages', languagesJson);
            formData.append('interests', interestsJson);

            const response = await post('', formData);
            // Match settings/profile.jsx: require real API success (result) before continuing
            if (response?.result) {
                dispatch(setInterestData(selectedInterests));
                markOnboardingCompleted();
                setStep();
            } else {
                alert('Failed to save your profile. Please try again.');
            }
        } catch (error) {
            console.log("Error in handleContinue:", error);
            alert('Failed to save your profile. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }

    const isExactlySelected = selectedInterests?.length === INTERESTS_REQUIRED;
    const isMaximumSelected = selectedInterests?.length >= INTERESTS_REQUIRED;

    return (
        <>
            <div className='p-[35px] h_90vh flex items-center justify-between w-full flex-col'>
                <div className='flex items-center justify-between w-full flex-col'>
                    <img src={InterestsIcon} className='w-24 h-24 mb-3' alt="Interests Icon" />
                    <h1 className='britti_medium fs_24'>Your Interests</h1>
                    <span className='txt_grey fs_16'>
                        Select 5 interests ({selectedInterests?.length}/5).
                    </span>
                    {loading ? (
                        <div className='h_50vh flex items-center justify-center'>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <div className='w-full mt-4 interestsGroup'>
                            {sortedInterestsList?.map((data, index) => (
                                <div className="interestItem" key={index}>
                                    <div className={selectedInterests?.includes(data?.name) ? "interest fs_14" : "flex items-center justify-center h-100 px-[12px] fs_14 border-1 border-transparent"}>
                                        {data?.name}
                                    </div>
                                    <input
                                        type="checkbox"
                                        checked={selectedInterests?.includes(data?.name)}
                                        onChange={(e) => handleCheckboxChange(e, data?.name)}
                                        disabled={submitting || (isMaximumSelected && !selectedInterests?.includes(data?.name))}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <button
                    onClick={() => handleContinue()}
                    disabled={!isExactlySelected || submitting}
                    className={`primary_btn w-full rounded-[15px] mt-4 ${(!isExactlySelected || submitting) ? 'opacity-50' : ''}`}
                >
                    {submitting ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Submitting...
                        </>
                    ) : (
                        'Continue'
                    )}
                </button>
            </div>
        </>
    )
}

export default Interests
